// Domain configuration utility
export const getDomainConfig = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const customDomain = process.env.REACT_APP_DOMAIN;
  
  return {
    domain: customDomain || (isProduction ? 'https://achrefsamoud.com' : 'http://localhost:3000'),
    siteName: process.env.REACT_APP_SITE_NAME || 'Achref Samoud Portfolio',
    description: process.env.REACT_APP_SITE_DESCRIPTION || 'Software Engineer & DevOps Researcher in Montreal, Quebec'
  };
};

// SEO utilities for dynamic meta tags
export const generateSEOProps = (section?: string) => {
  const config = getDomainConfig();
  
  const seoSections = {
    home: {
      title: `${config.siteName} | Software Engineer & DevOps Researcher in Montreal, QC`,
      description: `${config.description}. Full-stack developer with expertise in React, TypeScript, CI/CD automation, and cloud infrastructure.`,
      url: config.domain
    },
    about: {
      title: `About Achref Samoud | Montreal Software Engineer`,
      description: `Learn about Achref Samoud, a software engineer based in Montreal, Quebec specializing in React, DevOps research, and cloud infrastructure.`,
      url: `${config.domain}/#about`
    },
    experience: {
      title: `Experience | Achref Samoud - Montreal Software Engineer`,
      description: `Professional experience of Achref Samoud including Research Assistant at Telus, Teaching Assistant at ÉTS, and DevOps engineering roles in Montreal.`,
      url: `${config.domain}/#experience`
    },
    education: {
      title: `Education | Achref Samoud - Software Engineering Graduate`,
      description: `Educational background of Achref Samoud including Master's in Software Engineering at Université de Sherbrooke, Quebec.`,
      url: `${config.domain}/#education`
    },
    contact: {
      title: `Contact Achref Samoud | Montreal Software Engineer`,
      description: `Get in touch with Achref Samoud for software development projects in Montreal, Quebec. Available for DevOps engineering, cloud infrastructure, and React development.`,
      url: `${config.domain}/#contact`
    }
  };

  return seoSections[section as keyof typeof seoSections] || seoSections.home;
};